import Axios from "axios"


export async function get_link(props) {
    const link = props['link']

    const result = await Axios
                    .post("/consumer/link", {
                        link: link
                    })
    const data = result['data']

    // B8CT1%2BMuczStLDbBKdnWIA%3D%3D
    const q = {
        check: true,
        branch_id: ''
    }

    if(data['status'] === 'success') {
        q['check'] = false
        q['branch_id'] = data['data']
    }

    return q
}